import { gql } from "@apollo/client";

export const ELIMINAR_PRECIO_MASIVO = gql`
    mutation EliminarPrecioMasivo(
        $idPrecioMasivo: Int!
    ){
    eliminarPrecioMasivo(
            idPrecioMasivo: $idPrecioMasivo
    ) 
}
`;